import { render } from "./BottomPic.vue?vue&type=template&id=f85342da"
const script = {}

import "./BottomPic.vue?vue&type=style&index=0&id=f85342da&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__